//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import accordion from '~/mixins/accordion'

export default {
  mixins: [accordion],
  props: {
    showcase: Object
  }
}
